module.exports = __webpack_public_path__ + "img/8.7fd5cf88.jpg";